// ─── Common Site Configuration ───────────────────────────────────────────────
// Edit this file to update contact details, branding, and form behaviour
// across the entire site.

export const siteConfig = {
  name: 'Finegal Tech Solution',
  tagline: 'Your Trusted Partner in Finance, Legal & Tech Solutions',

  contact: {
    email: 'finegaltechsolution@gmail.com',
    phone: '+91 97184 31522',
    whatsapp: '919718431522',   // include country code, no + or spaces
    address: 'Flat No 102, First Floor, F-103 Vishwas Park, Uttam Nagar, New Delhi - 110059',
    hours: 'Mon–Sat: 9:00 AM – 7:00 PM',
  },

  social: {
    linkedin: 'https://linkedin.com',
    twitter: 'https://twitter.com',
    facebook: 'https://facebook.com',
    instagram: 'https://instagram.com',
    youtube: 'https://youtube.com',
  },

  // WhatsApp form: default greeting message prefix
  whatsappGreeting: 'Hello Finegal Tech Solution,\n\nI would like a free consultation.\n\n',

  // Services shown in the contact form dropdown
  services: [
    'GST Registration',
    'GST Return Filing',
    'Income Tax Return',
    'Company Registration',
    'ROC Compliance',
    'Trademark Registration',
    'ISO Certification',
    'Legal Consultation',
    'Website Development',
    'Other',
  ],
};
